<template>
  <div>
    <el-dialog
      ref="adjustDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h720_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('adjustDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAdjustForm"
          :model="dialogAdjustForm"
          :rules="dialogAdjustFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item label="订单类型">
                    <el-radio-group v-model="dialogViewForm.type">
                      <el-radio
                        :label="1"
                        disabled
                      >
                        委托制作
                      </el-radio>
                      <el-radio
                        :label="2"
                        disabled
                      >
                        购买
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="城市">
                    <el-input
                      v-model="dialogViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="供应商">
                    <el-input
                      v-model="dialogViewForm.supplierName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="订单日期">
                    <el-date-picker
                      v-model="dialogViewForm.orderDateValue"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="订单总金额">
                    <el-input
                      v-model="mathOrderTotal"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="预计制作完成日期">
                    <el-date-picker
                      v-model="dialogViewForm.estimatedCompleteDateValue"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="实际制作完成日期">
                    <el-date-picker
                      v-model="dialogViewForm.completeDateValue"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="经办人">
                    <el-input
                      v-model="dialogViewForm.manager"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item label="物料制作费用">
                    <el-input
                      v-model="mathMakeTotal"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="其他费用">
                    <el-input
                      v-model="dialogAdjustForm.otherAmount"
                      @input="(val)=>{limitNumber(val, dialogAdjustForm, 'otherAmount')}"
                      @blur="setNumberValueDefaultZero($event, dialogAdjustForm, 'otherAmount', 2)"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="其他费用说明"
                    prop="otherReason"
                  >
                    <el-input v-model="dialogAdjustForm.otherReason" />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              物料信息
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:10px;"
              >
                <el-col :span="24">
                  <el-table
                    :data="materialsTableData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                  >
                    <el-table-column
                      label="需求明细"
                      type="expand"
                      width="100"
                    >
                      <template slot-scope="scope">
                        <el-table
                          :data="scope.row.demandDetailList"
                          style="width: 100%"
                          :header-cell-style="{background:'#00d9ff'}"
                          border
                        >
                          <el-table-column
                            type="index"
                            label="序号"
                            width="60"
                          />
                          <el-table-column
                            prop="provinceName"
                            label="省区"
                            width="70"
                          />
                          <el-table-column
                            prop="cityName"
                            label="市场"
                            show-overflow-tooltip
                            width="100"
                          />
                          <el-table-column
                            prop="schemeContent"
                            label="需求来源"
                            width="200"
                            show-overflow-tooltip
                          />
                          <el-table-column
                            prop="materialsName"
                            label="需求物料"
                            show-overflow-tooltip
                            width="180"
                          />
                          <el-table-column
                            prop="auditMakeNumber"
                            label="需求数量"
                            width="100"
                          />
                          <el-table-column
                            prop="demandSide"
                            label="需求方"
                            width="100"
                            show-overflow-tooltip
                          />
                          <el-table-column
                            prop="receiver"
                            label="收货人"
                            width="100"
                          />
                          <el-table-column
                            prop="receivePhone"
                            label="联系电话"
                            width="120"
                          />
                          <el-table-column
                            prop="receiveAddress"
                            label="收货地址"
                            show-overflow-tooltip
                            width="200"
                          />
                        </el-table>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="materialsName"
                      label="物料名称"
                    />
                    <el-table-column
                      prop="materialsSpecification"
                      label="物料规格"
                      width="100"
                    />
                    <el-table-column
                      prop="materialsUnit"
                      label="物料单位"
                      width="90"
                    />
                    <el-table-column
                      label="制作单价(元)"
                      width="150"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.makePrice"
                          @input="(val)=>{computedMathRow(val, scope.row, 'makePrice')}"
                          @blur="setMaterialsPriceValue($event, scope.row, 'makePrice')"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="makeNumber"
                      label="数量"
                      width="120"
                    />
                    <el-table-column
                      label="金额"
                      width="120"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.makeAmount }}
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAdjustForm.remark"
                      type="textarea"
                      placeholder="备注"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          :disabled="operateButtonDisable"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 数据请求
import { initCommissionedOrderApi, adjustCommissionedOrderApi } from '@/api/materialsCommissionedOrder'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    },
    sendArray: {
      type: Array,
      default: null
    },
    supplier: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',

      dialogViewForm: {},
      dialogAdjustForm: {},
      dialogAdjustFormRules: {
        otherReason: [{ max: 255, message: '其他费用说明最多输入255个字符', trigger: 'blur' }],
        remark: [{ max: 1024, message: '备注最多输入1024个字符', trigger: 'blur' }]
      },
      // 委托制作物料明细
      materialsTableData: []
    }
  },
  computed: {
    // 计算物料制作费用总金额
    mathMakeTotal() {
      return this.materialsTableData.reduce((prev, item) => {
        return this.formatNumber(prev + Number(item.makeAmount), 2)
      }, 0)
    },
    // 计算订单总金额
    mathOrderTotal() {
      let total = Number(this.mathMakeTotal) + Number(this.dialogAdjustForm.otherAmount)
      return total
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.loading = true
        this.loadingText = '努力加载数据中，请耐心等待'
        this.operateButtonDisable = false

        this.dialogViewForm = {}
        this.dialogAdjustForm = {
          id: '',
          orderAmount: 0,
          makeAmount: 0,
          otherAmount: 0,
          otherReason: '',
          remark: '',
          orderDetails: '', // 制作物料明细JSON字符串]
        }
        this.materialsTableData = []
        this.initData()

        this.$nextTick(() => {
          this.$refs.dialogAdjustForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    initData() {
      initCommissionedOrderApi({ id: this.dataId, operate: 'edit' }).then(response => {
        const { data } = response
        let orderData = data.materialsCommissionedOrder
        this.dialogViewForm = orderData
        for (let key in this.dialogAdjustForm) {
          if (key.endsWith('Date')) this.dialogAdjustForm[key] = orderData[key + 'Value']
          else this.dialogAdjustForm[key] = orderData[key]
        }
        this.dialogAdjustForm.id = orderData.id
        this.materialsTableData = data.orderDetailList

        this.loading = false
      })
    },
    // 计算每一项物料制作金额
    computedMathRow(val, obj, name) {
      this.limitPositiveNumber(val, obj, name)
      this.setNumberZero(obj, name)
      obj['makeAmount'] = this.formatNumber(Number(obj['makePrice']) * Number(obj['makeNumber']), 2)
    },
    // 物料明细单价输入框失去焦点响应事件
    setMaterialsPriceValue(event, obj, name) {
      this.setNumberValueDefaultZero(event, obj, name, 2)
      obj['makeAmount'] = this.formatNumber(Number(obj['makePrice']) * Number(obj['makeNumber']), 2)
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAdjustForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      this.$refs.dialogAdjustForm.validate(valid => {
        if (valid) {
          this.$confirm(
            '是否确定保存物料委托制作单', '系统提示',
            { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
          )
            .then(async () => {
              this.operateButtonDisable = true
              this.loading = true
              this.loadingText = '正在处理数据中，请耐心等待'

              this.dialogAdjustForm.makeAmount = Number(this.mathMakeTotal)
              this.dialogAdjustForm.orderAmount = Number(this.mathOrderTotal)
              this.dialogAdjustForm.orderDetails = JSON.stringify(this.materialsTableData)

              adjustCommissionedOrderApi(this.dialogAdjustForm).then(res => {
                if (res.mark === '200') {
                  this.$message({ message: res.message, type: 'success' })
                  this.reloadData()
                  this.modalClose()
                }
              }).catch(() => {
                this.loading = false
                this.operateButtonDisable = false
              })
            })
            .catch(() => { })
        }
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
  .cell {
    line-height: 16px;
  }
}
</style>
